import React from 'react'
import PropTypes from 'prop-types'

const EmailField = ({ email }) => (
  <div className="field">
    <label style={{ fontSize: '16px' }}>Email</label>
    <input
      readOnly
      name="email"
      placeholder="Email"
      value={email ? email : ''}
      style={{
        backgroundColor: '#f0f0f0',
        color: '#888888',
      }}
    />
  </div>
)

EmailField.propTypes = {
  email: PropTypes.string,
}

export default EmailField



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/AccountCompletionForm/EmailField/index.js